import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-config-selection',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-config-selection.component.html',
  styleUrl: './modal-config-selection.component.scss'
})
export class ModalConfigSelectionComponent implements OnChanges {
  @Input() showModal: boolean = false;
  @Input() availableConfigs: any[] = [];
  @Input() fuenteName: string = '';
  @Input() loading: boolean = false;
  @Output() modalClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() configSelected: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges) {
    console.log('[ModalConfigSelection] Changes:', {
      showModal: this.showModal,
      availableConfigs: this.availableConfigs,
      fuenteName: this.fuenteName,
      loading: this.loading
    });
  }

  closeModal() {
    console.log('[ModalConfigSelection] Cerrando modal');
    this.showModal = false;
    this.modalClose.emit(false);
  }

  selectConfig(config: any) {
    console.log('[ModalConfigSelection.selectConfig]  INICIO - Config:', config);
    console.log('[ModalConfigSelection.selectConfig] Emitiendo evento configSelected...');
    this.configSelected.emit(config);
    console.log('[ModalConfigSelection.selectConfig] Evento emitido, cerrando modal...');
    this.closeModal();
    console.log('[ModalConfigSelection.selectConfig]  FIN');
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
